import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from "configs/AppConfig";
import { authStore } from "stores/auth.store";
import Loading from "components/shared-components/Loading";

const ProtectedRoute = () => {
  const { isAuthenticated, authChecked } = authStore();

  const location = useLocation();

  if (!authChecked) return <Loading cover="page" />;
  if (!isAuthenticated) {
    return (
      <Navigate
        to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
